import { defineRouting } from "next-intl/routing";

const locales = ["en", "de"];
const defaultLocale = "de";

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: "as-needed",
  pathnames: {
    "/": "/",
    "/imprint": { de: "/impressum", en: "/imprint" },
    "/privacy": { de: "/datenschutz", en: "/privacy" },
    "/qr": { de: "/qr", en: "/qr" },
    "/hosting": { de: "/hosting", en: "/hosting" },
  },
});
